import { render, staticRenderFns } from "./categoriasFilters.vue?vue&type=template&id=2138b293"
import script from "./categoriasFilters.vue?vue&type=script&lang=js"
export * from "./categoriasFilters.vue?vue&type=script&lang=js"
import style0 from "./categoriasFilters.vue?vue&type=style&index=0&id=2138b293&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports